import React from "react"
import { Link, navigate } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import { Spin } from "antd"
import axios from "axios"

const isBrowser = typeof window !== "undefined"
const firebase = isBrowser ? require("firebase/app") : "div"
const firestore = isBrowser ? require("firebase/firestore") : "div"
const firebaseui = isBrowser ? require("firebaseui") : "div"
const Styles = styled.div`
  padding-top: 84px;
  min-height: 80vh;
`

export default class extends React.Component {
  constructor(props) {
    super()
    this.state = {}
  }
  componentDidMount() {
    if (typeof window === undefined) {
      return
    }

    var ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth())

    ui.start("#firebaseui-auth-container", {
      signInSuccessUrl: "/workspace/",
      tosUrl: "/tos/",
      callbacks: {
        signInSuccessWithAuthResult: function(result, redirectUrl) {
          this.handleResult(result)
        }.bind(this),
      },
      privacyPolicyUrl: "/privacy-policy",
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },

        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },

        {
          provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },

        // {
        //   provider: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        //   scopes: ["email"],
        // },

        {
          provider: firebase.auth.GithubAuthProvider.PROVIDER_ID,
          scopes: ["email"],
        },
      ],
    })
  }

  async handleResult(result) {
    let email = result.user.providerData[0].email;
    let profile = await firebase.firestore().collection("profiles").doc(email).get();
    if ( !profile.exists ) {
      // let resp = await axios({
      //   method: 'post',
      //   url: 'https://api.stripe.com/v1/customers',
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded",
      //     "Authorization": "Bearer xxx",
      //   },
      //   data: `email=${ email }`
      // })
      // let stripeCustomerId = resp.data.id
      await firebase.firestore().collection("profiles").doc(email).set({ email, views: 0, graduated: false, graduation: { url: "", time: ""}});
      navigate("account") 
      
    } else {
      navigate("account")  
    }
      
    
  }

  render() {
    return (
      <Layout path="login">
        <SEO title="consultare.io" />
        
          <Styles>
            <Container>
              <div className="title is-1 has-text-centered">
                Login
              </div>
            <div id="firebaseui-auth-container"></div>
            </Container>
          </Styles>


      </Layout>
    )
  }
}

